import React, { Component } from "react";

// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { withStyles } from "@material-ui/core/styles";
import { useTheme } from '@material-ui/core/styles';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';
import Button from "components/CustomButtons/Button.js";

import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import HeaderRightLinks from "components/Header/HeaderRightLinks.js";
import HeaderLeftLinks from "components/Header/HeaderLeftLinks.js";

import './ContactPage.css';
import styles from "assets/jss/material-kit-react/views/componentsSections/basicsStyle.js";
const useStyles = makeStyles(styles);
const dashboardRoutes = [];
const clearFields = {
    usersName: '',
    usersAddress: '',
    usersPhone: '',
    usersEmail: '',
    usersMessage: ''
}

class ContactPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userType: '',
            usersName: '',
            usersAddress: '',
            usersPhone: '',
            usersEmail: '',
            usersMessage: ''
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    };

    selectUserType = (event) => {
        this.setState({ userType: event.target.value, clearFields }, console.log(this.state));
    }

    render() {
        const { classes } = this.props;
        return (
            <div className="contact-page">
                <Header
                    color="white"
                    routes={dashboardRoutes}
                    rightLinks={<HeaderRightLinks />}
                    leftLinks={<HeaderLeftLinks />}
                    fixed
                    changeColorOnScroll={{
                        height: 400,
                        color: "white"
                    }}
                />

                <main className={`${classes.container} contact-container`}>
                    <img
                        className="contact-map-bg"
                        src={require('assets/img/FF_map_only.png')}
                        alt=""
                        aria-hidden="true"
                    />

                    <header className="contact-header">
                        <h1>Contact Us</h1>
                    </header>

                    <section className="contact-layout">
                        <div className="contact-intro">
                            <p className="contact-copy">
                                Thank you for contacting us at Finding Faber. We are here to help you connect to local customers in real time. In order to do so, please fill out the following fields and we will get back to you right away.
                            </p>
                            <div className="contact-role">
                                <FormHelperText className="contact-role-helper">What is your role?</FormHelperText>
                                <FormControl variant='outlined' color='primary' className="contact-role-select">
                                <InputLabel id='usertypelabel'>I am a...</InputLabel>
                                <Select labelId='usertypelabel' id="usertypeselect" label='I am a...'
                                    value={this.state.userType}
                                    onChange={this.selectUserType}
                                >
                                    <MenuItem value='business'>Business Owner</MenuItem>
                                    <MenuItem value='user'>Finding Faber User</MenuItem>
                                </Select>
                                </FormControl>
                            </div>
                        </div>

                        <div className="contact-form-panel">
                            {this.state.userType === 'business' || this.state.userType === 'user' ?
                                <form className="contact-form">
                                    <TextField
                                        // helperText={this.state.editMerchantNameErr ? this.state.editMerchantNameErr : null} 
                                        variant='outlined'
                                        className="contact-field"
                                        name="usersName" label={this.state.userType === 'business' ? 'Business Name' : 'Name'}
                                    // onFocus={() => this.setState({ focusedInput: "MerchantName" })} 
                                    // value={this.state.editMerchantName} onChange={this.handleInputChange} 
                                    />

                                    {this.state.userType === 'business' ?
                                        <TextField
                                            // helperText={this.state.editMerchantNameErr ? this.state.editMerchantNameErr : null} 
                                            variant='outlined'
                                            className="contact-field"
                                            name="usersAddress" label='Business Address'
                                        // onFocus={() => this.setState({ focusedInput: "MerchantName" })} 
                                        // value={this.state.editMerchantName} onChange={this.handleInputChange} 
                                        /> : <> </>}

                                    <TextField
                                        // helperText={this.state.editMerchantNameErr ? this.state.editMerchantNameErr : null} 
                                        variant='outlined'
                                        className="contact-field"
                                        name="usersPhone" label='Phone'
                                    // onFocus={() => this.setState({ focusedInput: "MerchantName" })} 
                                    // value={this.state.editMerchantName} onChange={this.handleInputChange} 
                                    />

                                    <TextField
                                        // helperText={this.state.editMerchantNameErr ? this.state.editMerchantNameErr : null} 
                                        variant='outlined'
                                        className="contact-field"
                                        name="usersEmail" label='Email'
                                    // onFocus={() => this.setState({ focusedInput: "MerchantName" })} 
                                    // value={this.state.editMerchantName} onChange={this.handleInputChange} 
                                    />

                                    <TextField
                                        // helperText={this.state.editMerchantNameErr ? this.state.editMerchantNameErr : null} 
                                        variant='outlined'
                                        className="contact-field"
                                        name="usersMessage" label='Your Message'
                                        multiline
                                        rows={4}
                                    // onFocus={() => this.setState({ focusedInput: "MerchantName" })} 
                                    // value={this.state.editMerchantName} onChange={this.handleInputChange} 
                                    />

                                    <Button color="primary" className="contact-submit">Submit</Button>
                                </form> :
                                <div className="contact-empty-state">
                                    <span>Select a role to continue.</span>
                                </div>}
                        </div>
                    </section>
                </main>
                <Footer />
            </div>
        );
    }
}

export default withStyles(styles, { withTheme: true })(ContactPage);
